/**
 * Orders Domain Constants
 */

// ============================================
// Pagination
// ============================================

export const DEFAULT_PAGE_SIZE = 10
export const MAX_PAGE_SIZE = 1000

// ============================================
// Default Values
// ============================================

export const DEFAULT_CURRENCY = 'SAR'

export const DEFAULT_PRODUCT_NAME = {
  en: 'Unknown Product',
  ar: 'منتج غير معروف',
} as const

// ============================================
// API Endpoints
// ============================================

export const ORDER_ENDPOINTS = {
  LIST: '/api/orders',
  DETAIL: (id: string) => `/api/orders/${id}`,
  CREATE: '/api/orders',
  UPDATE: (id: string) => `/api/orders/${id}`,
  DELETE: (id: string) => `/api/orders/${id}`,
  BULK_CANCEL: '/api/orders/bulk-cancel',
  BULK_FORCE_STATUS: '/api/orders/bulk-force-status',
  OFFLINE_ENTRY: '/api/orders/offline-entry',
  STATS: '/api/orders/stats',
  SEND_SMS: (id: string) => `/api/orders/${id}/send-sms`,
  SALES_ORDER_DETAIL: (id: string) => `/api/sales-orders/${id}`,
  SALES_ORDER_LIST: '/api/sales-orders',
} as const

// ============================================
// Status Mappings (API → Domain)
// ============================================

export const API_ORDER_STATUS_TO_DOMAIN = {
  planned: 'pending',
  processing: 'processing',
  in_transit: 'in-transit',
  delivered: 'delivered',
  canceled: 'cancelled',
  failed: 'cancelled',
} as const

// ============================================
// Status Mappings (Domain → API)
// ============================================

export const DOMAIN_ORDER_STATUS_TO_API = {
  pending: 'planned',
  processing: 'processing',
  'in-transit': 'in_transit',
  delivered: 'delivered',
  cancelled: 'canceled',
} as const

// ============================================
// Order Number Prefix
// ============================================

export const ORDER_NUMBER_PREFIX = 'ORD'
